import React from 'react';
import { Legend } from './style';

const MobilityLegend = ({ color }) => {
  return <Legend color={color} />;
};

export default MobilityLegend;
